import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Card, RadioGroup, Radio, H3, Icon, FormGroup, InputGroup } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';


class SelectPartKeys extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      selected: this.props.collPartKeys[0],
      maxPartitions: "*"
    }
  }

  handlePartKeyChange = (e) => {
    const value = e.target.value;
    this.setState({ selected: value });
  }

  setPartsReady = () => {
    this.setState(
      prevState => ({ ready: !prevState.ready }), () => {
        this.props.onPartReady(this.state.selected,this.state.maxPartitions);
      }
    );
  }
  onChangemaxPartitions = (e) => {
      const value = e.target.value;
      this.setState({ maxPartitions: value });
  };
  

  render() {
    const { ready } = this.state;
    const { t } = this.props;

    const partKeysClasses = classNames(
      'margin-bottom-1-rem',
      'margin-right-05-rem',
      {'active-card': !this.state.ready},
      {'success-card': this.state.ready},
    );

    
    return (
      <Card elevation={2} className={partKeysClasses}>
        <div className="flex flex-between">
          <H3 className="margin-bottom-1-5rem">{t('partKeys')}</H3>
          <Icon icon={IconNames.CROSS} iconSize={Icon.SIZE_LARGE} onClick={this.props.onDeletePart} />
        </div>
        <FormGroup 
          label={t('maxPartitions')} 
          lableInfo={t('maxPartitionsExplanation')}
          labelFor="maxPartitions" inline={true}>
          <InputGroup
            id="maxPartitions"
            name="maxPartitions"
            value={this.state.maxPartitions}
            onChange={this.onChangeName}
          />
        </FormGroup>
        <RadioGroup onChange={this.handlePartKeyChange} selectedValue={this.state.selected}>
            { this.props.collPartKeys.map( part => 
              <Radio key={part} label={part} value={part} />
            )}
        </RadioGroup>


        {!ready && <Button text={t('validate')} onClick={this.setPartsReady} />}
      </Card>
    );
  }
}

SelectPartKeys.propTypes = {
  // partKeys varies depending on the base collection selected by the user
  collPartKeys: PropTypes.arrayOf(PropTypes.string),
  onPartReady: PropTypes.func,
  onDeletePart: PropTypes.func,
};

export default withTranslation()(SelectPartKeys);
